import React from "react";
import "./download.style.sass";
import { Col, Row } from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectToggleModalIos } from "../../redux/site/site.selector";
import { ToggleModalIos } from "../../redux/site/site.actions";
import IosModal from "../../modals/IosModal/ios.modal";
import Axios from "axios";
import { Setting } from "../../setting";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";

class DownloadLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
    };
  }

  componentDidMount() {
    Axios.get(`${Setting.apiUrl}api/download/list`).then((res) => {
      this.setState({
        data: res.data,
      });
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { data } = this.state;
    document.getElementById("contentOfDownload").innerHTML = data.content;
  }

  render() {
    const { iosModal, ToggleModalIos } = this.props;
    const { data } = this.state;
    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
      position: relative;
    `;
    return (
      <div className="download-layout">
        <div className="download-content">
          <h2 className="download-title">
            دانلود از <span>زیتونیکس</span>
          </h2>
          <div className="download-main">
            {data ? (
              <div>
                <Row>
                  {/*  ANDROID STATW  */}
                  <Col md={8} sm={12} xs={24} className="md-mb-3">
                    <div className="download-main-title">
                      <h6>
                        اپلیکیشن ({" "}
                        <span>
                          <strong>X</strong>
                        </span>
                        itoni
                        <span>
                          <strong>X</strong>
                        </span>{" "}
                        ) ویژه اندروید
                      </h6>
                    </div>
                    <div className="download-main-content">
                      {data.android.map((item, i) => (
                        <a
                          key={i}
                          href={`https://${item.url}`}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <img
                            src={`${Setting.apiUrl}${item.img}`}
                            alt="xitonix download"
                          />
                        </a>
                      ))}
                    </div>
                  </Col>
                  {/*  FINISH ANDROID   */}
                  {/*   IOS STATE   */}
                  <Col md={8} sm={12} xs={24} className="md-mb-3">
                    <div className="download-main-title">
                      <h6>
                        اپلیکیشن ({" "}
                        <span>
                          <strong>X</strong>
                        </span>
                        itoni
                        <span>
                          <strong>X</strong>
                        </span>{" "}
                        ) ویژه ios
                      </h6>
                    </div>
                    <div className="download-main-content">
                      {data.ios.map((item, i) => (
                        <a
                          key={i}
                          href={`https://${item.url}`}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <img
                            src={`${Setting.apiUrl}${item.img}`}
                            alt="xitonix download"
                          />
                        </a>
                      ))}
                    </div>
                  </Col>
                  {/*  FINISH IOS  */}
                  {/*  GIDE STATE  */}
                  <Col md={8} sm={12} xs={24} className="md-mb-3">
                    <div className="download-main-title">
                      <h6>
                        دفترچه راهنمای محصولات ({" "}
                        <span>
                          <strong>X</strong>
                        </span>
                        itoni
                        <span>
                          <strong>X</strong>
                        </span>{" "}
                        )
                      </h6>
                    </div>
                    <div className="download-main-content">
                      {data.note.map((item, i) => (
                        <a
                          key={i}
                          href={`${Setting.apiUrl}${item.url}`}
                          target="_blank"
                          rel="noreferrer"
                          download
                        >
                          <img
                            src={`${Setting.apiUrl}${item.img}`}
                            alt="xitonix download"
                          />
                        </a>
                      ))}
                    </div>
                  </Col>
                  {/*  FINISH GIDE  */}
                </Row>
                <br />
                <Row>
                  <Col xs={24}>
                    <div
                      className="download-content-content"
                      id="contentOfDownload"
                    />
                  </Col>
                </Row>
              </div>
            ) : (
              <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
            )}
          </div>
        </div>

        {/* MODALS */}

        <IosModal iosModal={iosModal} ToggleModalIos={ToggleModalIos} />
      </div>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  iosModal: selectToggleModalIos,
});
const mapDispatchToProps = (dispatch) => ({
  ToggleModalIos: () => dispatch(ToggleModalIos()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadLayout);
